import React from 'react';
import { Typography, RefreshIcon, IconButton } from '@kareo/design-system';
import { Grid } from '@material-ui/core';
var GeneralError = function (_a) {
    var reloadData = _a.reloadData;
    return (React.createElement(Grid, { container: true, direction: "column", justify: "center" },
        React.createElement(Grid, { item: true, container: true, alignItems: "center" },
            React.createElement(Grid, { item: true },
                React.createElement(Typography, { variant: "body1", color: "error" }, "We're having trouble loading this data")),
            React.createElement(Grid, { item: true },
                React.createElement(IconButton, { size: "small", onClick: reloadData },
                    React.createElement(RefreshIcon, { fontSize: "small", color: "primary" }))))));
};
export default GeneralError;
